// 导入axios库
import axios from 'axios';

// 创建 Axios 实例，配置默认请求参数
const apiClient = axios.create({
    // 根据环境设置不同的API基础地址：生产环境使用线上服务器，开发环境使用本地服务器
    baseURL: process.env.NODE_ENV === 'production' ? 'https://doushujun.me/api' : 'http://192.168.31.100:8000/api',
    // 设置请求超时时间为60秒
    timeout: 180000,
    // 注意：不能设默认 Content-Type（原 application/json 头会让 axios 1.x 把 FormData
    // 序列化成 {"file":{}}，头像等 multipart 上传后端拿不到文件）。去掉后按数据自动设置。
});

// 请求拦截器：在发送请求前添加认证信息和签名
apiClient.interceptors.request.use(
     (config) => {
        // 从localStorage获取token
        const token = localStorage.getItem('token');
        // 如果存在token，添加到请求头中
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        // 请求错误时返回rejected Promise
        return Promise.reject(error);
    }
);

// 响应拦截器：统一处理响应错误
apiClient.interceptors.response.use(
    (response) => {
        // 成功响应，直接返回
        return response;
    },
    (error) => {
        if (error.response) {
            const status = error.response.status;
            const data = error.response.data;
            
            // 记录API错误信息
            console.error('API Error:', status, data);

            // 处理网络连接错误
            if (error.code === 'ERR_NETWORK') {
                console.error('网络连接错误，请检查服务器是否可访问');
            }

            // 处理503站点维护错误
            if (status === 503) {
                console.log('%c🔴 拦截器检测到503错误，准备跳转...', 'color: #f56c6c; font-weight: bold; font-size: 14px;');
                
                const closeMessage = (data && data.msg) || '系统维护中，请稍后访问...';
                const reopenTime = (data && data.data && data.data.expected_reopen_time) || '';
                
                console.log('  - 保存消息:', closeMessage);
                console.log('  - 恢复时间:', reopenTime);
                
                // 保存到localStorage
                localStorage.setItem('siteCloseMessage', closeMessage);
                localStorage.setItem('siteReopenTime', reopenTime);
                
                // 跳转到站点关闭页面
                console.log('  - 执行跳转: /site-closed');
                window.location.href = '/site-closed';
                
                // 阻止后续代码执行
                return;
            }

            // 处理401未授权错误（Token无效或已过期）
            if (status === 401) {
                // 清除本地存储的用户信息
                localStorage.removeItem('userLoggedIn');
                localStorage.removeItem('username');
                localStorage.removeItem('userBalance');
                localStorage.removeItem('token');
                localStorage.removeItem('userEmail');

                // 如果在浏览器环境中，触发自定义事件通知Vue组件显示登录模态框
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(new CustomEvent('tokenExpired'));
                }
            }

            // 处理403被挤下线错误（账号在其他设备登录）
            if (status === 403 && data && data.data && data.data.kicked_out) {
                // 清除本地存储的用户信息
                localStorage.removeItem('userLoggedIn');
                localStorage.removeItem('username');
                localStorage.removeItem('userBalance');
                localStorage.removeItem('token');
                localStorage.removeItem('userEmail');

                // 触发被挤下线事件
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(new CustomEvent('sessionKickedOut', {
                        detail: { message: data.msg || '您的账号已在其他设备登录' }
                    }));
                }
            }
        } else {
            // 记录请求失败信息
            console.error('Request failed:', error.message);
        }
        return Promise.reject(error);
    }
);

// 导出配置好的axios实例
export default apiClient;

// 导出纯净的axios实例（不带拦截器，用于站点状态检查等特殊场景）
export const cleanApiClient = axios.create({
    // 根据环境设置不同的API基础地址：生产环境使用线上服务器，开发环境使用本地服务器
    // 注意：必须与上方 apiClient 保持一致（历史遗留的 192.168.31.74 为死 IP，勿再使用）
    baseURL: process.env.NODE_ENV === 'production' ? 'https://doushujun.me/api' : 'http://192.168.31.100:8000/api',
    // 设置请求超时时间为10秒
    timeout: 10000,
    // 设置默认请求头
    headers: {
        'Content-Type': 'application/json',
    },
});